import { Component, TrackByFunction } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
  switchMap,
} from 'rxjs/operators';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { AllGroupsDropdown, AllRetailPlacesDropdown, Filter } from './users-page.types';
import { UtilsService } from '../../../core/services/utils.service';
import { UsersService } from '../user.service';
import { User } from '../../../core/modules/users/users.types';
import { Group } from '../../../core/modules/groups/groups.types';
import { GroupsApiService } from '../../../core/modules/groups/groups-api.service';
import { RetailPlacesApiService } from '../../../core/modules/retail-places/retail-places-api.service';
import { RetailPlace } from '../../../core/modules/retail-places/retail-paces.types';

@Component({
  selector: 'tax-users',
  templateUrl: './users-page.component.html',
  styleUrls: ['./users-page.component.sass'],
})

export class UsersPageComponent {
  readonly groups: Filter<Group, AllGroupsDropdown> = {
    defaultItem: {
      id: 0, title: 'ddlist.all.groups',
    },
    items$: this.groupsApiService.fetchGroups(0, '')
      .pipe(
        map(response => [this.groups.defaultItem].concat(response)),
      ),
  };

  readonly retailPlaces: Filter<RetailPlace, AllRetailPlacesDropdown> = {
    defaultItem: {
      id: 0, title: 'ddlist.all.retail.places',
    },
    items$: this.retailPlacesApiService.fetchRetailPlaces()
      .pipe(
        map(response => [this.retailPlaces.defaultItem].concat(response)),
      ),
  };

  readonly selectedGroupChanged$ = new BehaviorSubject<number>(this.groups.defaultItem.id);
  readonly selectedRetailPlaceChanged$ = new BehaviorSubject<number>(this.retailPlaces.defaultItem.id);

  readonly trackById: TrackByFunction<User> = this.utilsService.trackById;

  readonly usernameControl: FormControl<string> = new FormControl<string>('', {
    nonNullable: true,
  });

  readonly users$: Observable<User[]>;

  private readonly usernameChanged$: Observable<string> = this.usernameControl.valueChanges
    .pipe(
      // TODO: change behaviour. On 'enter' press and on clean don't need debounceTime
      startWith(this.usernameControl.value),
      debounceTime(1000),
      distinctUntilChanged(),
    );

  constructor(
    private utilsService: UtilsService,
    private groupsApiService: GroupsApiService,
    private retailPlacesApiService: RetailPlacesApiService,
    private usersService: UsersService,
  ) {
    this.users$ = combineLatest([
      this.selectedGroupChanged$,
      this.selectedRetailPlaceChanged$,
      this.usernameChanged$,
    ])
      .pipe(
        switchMap(([group, retailPlace, username]) => this.usersService.getUsers(username, retailPlace, group)),
      );
  }
}
